<template>
    <v-container fluid>
      <v-row v-if="!loadingSave" justify="center">
        <v-col cols="12">
          <v-row justify="center" class="mt-n8 mx-1 mb-4">
            <v-icon class="mx-2" size="35px">receipt_long</v-icon>
  
            <span style="font-size: 34px; color: #616161">Documentos recibidos DGII</span>
          </v-row>
          <v-row justify="center">
            <search-header
              class="pt-0 mt-0 pb-2"
              @dataFilters="changeBusiness($event)"
              :selected_week="2"
              :show_department="false"
              :show_location="false"
              :type="false"
            />
          </v-row>
          <!-- <v-row align="center" justify="center" class="pb-2">
            <v-col md="2" class="pt-0">
              <v-autocomplete
                v-model="invoice_type"
                outlined
                dense
                hide-details
                :items="[
                  { value: 0, text: 'Todo' },
                  { value: 2, text: 'Venta directa' },
                  { value: 5, text: 'Vouchers / credito empleado' },
                  { value: 8, text: 'Bonos' },
                ]"
                label="Tipo de factura"
              ></v-autocomplete>
            </v-col>
            <v-col md="3" class="pt-0">
              <v-row>
                <v-col md="6">
                  <v-autocomplete
                    v-model="invoice_category"
                    outlined
                    dense
                    hide-details
                    :items="item_categories"
                    label="Categoria"
                  ></v-autocomplete>
                </v-col>
                <v-col md="6">
                  <v-autocomplete
                    v-model="currency_filter"
                    outlined
                    dense
                    hide-details
                    :items="[
                      { value: 0, text: 'Todas' },
                      { value: 1, text: 'DOP' },
                      { value: 2, text: 'HTG' },
                      { value: 3, text: 'USD' },
                    ]"
                    label="Moneda"
                  ></v-autocomplete>
                </v-col>
              </v-row>
            </v-col>
            <v-col md="2" class="pt-0">
              <v-autocomplete
                v-model="box_filter"
                outlined
                dense
                hide-details
                :items="boxes_computed"
                label="Caja"
              ></v-autocomplete>
            </v-col>
            <v-col md="2" class="pt-0">
              <v-autocomplete
                v-model="customer_filter"
                outlined
                dense
                hide-details
                :items="customers"
                label="Cliente"
              ></v-autocomplete>
            </v-col>
            <v-col md="2" class="pt-0">
              <v-autocomplete
                v-model="branche_filter"
                outlined
                dense
                :disabled="customer_filter < 0"
                hide-details
                :items="branches"
                label="Sucursal"
              ></v-autocomplete>
            </v-col>
          </v-row> -->
          <v-card elevation="0" class="rounded-lg mt-2 ">
            <v-expand-transition>
              <v-row v-if="loading" justify="center">
                <v-col cols="12" md="10">
                  <v-skeleton-loader
                    type="list-item-avatar, divider, list-item-three-line, card-heading, image, actions"
                  >
                  </v-skeleton-loader>
                </v-col>
              </v-row>
              <v-data-table
                v-else
                height="80vh"
                :search="search"
                :headers="headers"
                :items-per-page="50"
                :items="invoices"
                class="elevation-0"
                dense
                fixed-header
                hide-default-footer
                @page-count="pageCount = $event"
                :page.sync="page"
              >
                <template v-slot:top>
                  <v-toolbar class="elevation-0 rounded-lg">
                   
                    <v-spacer></v-spacer>
                    <v-col md="4">
                      <v-text-field
                        label="Buscar..."
                        class="mt-0"
                        v-model="search"
                        outlined
                        dense
                        hide-details
                      ></v-text-field>
                    </v-col>
                    <v-spacer></v-spacer>
                   
                 
                    <!-- <v-btn icon class="pb-3" @click="dialog_settings=true"><v-icon>settings</v-icon></v-btn> -->
                  </v-toolbar>
                </template>
                <template v-slot:[`item.Encf`]="{ item }">
                <v-hover v-slot="{ hover }">
                  <span
                    @click="showDocument(item.RncReceptor, item.Encf)"
                    class="primary--text font-weight-normal text-truncate font-weight-semibold"
                    :style="{
                      color: hover ? 'red' : 'black',
                      cursor: hover ? 'pointer' : '',
                      'text-decoration': hover ? 'underline' : '',
                    }"
                  >
                  

                    {{ item.Encf }}

                  
                  </span>
                </v-hover>
                <br />
              </template>
              <template v-slot:item.tipoCF="{ item }">
                {{ item.tipoCF }}
              </template>
      
              <!-- Formato para Monto Total -->
              <template v-slot:item.MontoTotal="{ item }">
                {{ formatCurrency(item.MontoTotal) }}
              </template>
              <!-- Formato para Fecha Emisión -->
              <template v-slot:item.FechaEmision="{ item }">
                {{ formatDate(item.FechaEmision) }}
              </template>
              <!-- Formato para Fecha Recepción -->
              <template v-slot:item.FechaRecepcion="{ item }">
                {{ formatDate(item.FechaRecepcion) }}
              </template>
       
                <template v-slot:no-data>
                  <v-row justify="center" class="pt-10">
                    <v-icon size="80px">token</v-icon>
                  </v-row>
                  <v-row justify="center" class="pb-6"> No hay datos </v-row>
                </template>
                <template slot="footer">
                  <v-row justify="center">
                    <v-container style="width: 70%" class="mt-4">
                      <v-pagination v-model="page" :length="pageCount"></v-pagination>
                    </v-container>
                  </v-row>
                </template>
              </v-data-table>
            </v-expand-transition>
          </v-card>
  
        </v-col>
      </v-row>
   

    </v-container>
  </template>
  
  <script>
  import moment from "moment";
  export default {
    data: () => ({
      loadingSave: false,
      editOrCopyStatus: false,
      page: 1,
      pageCount: 0,
      search: "",
      search_invoice: null,
      loading: false,
    
      item_categories: [
        { value: 0, text: "Todo" },
        { value: 1, text: "Contado/efectivo" },
        { value: 2, text: "Credito" },
      ],
    
      headers: [
        { text: "NCF", value: "Encf", width: "12%" },
        { text: "Tipo e-CF", value: "tipoCF", align: "center", width: "8%" },
       // { text: "Descripción", value: "tipoCFDescription", width: "20%", sortable: false },
        { text: "RNC Emisor", value: "RncEmisor" },
        { text: "Emisor", value: "emisorName" },
        { text: "Fecha Emisión", value: "FechaEmision" },
        { text: "Fecha Recepción", value: "FechaRecepcion" },
        { text: "Monto Total", value: "MontoTotal", align: "end" },
        //{ text: "Estado", value: "Estado" },
       // { text: "Ambiente", value: "Ambiente" }
      ],
      lastFilters: {},
      editedIndex: -1,
  
      editedItem: {},
    }),
    computed: {
    
    },
    watch: {},
    created() {
     // this.init();
    },
    methods: {
    
      async getData(data) {

        const businessUnit = this.$store.state.auth.bussines_units.find(
        (element) => element.value === data.business
      );
      
        this.lastFilters = data;
        this.loading = true;
        let filters = "";
        filters += `WHERE "RncReceptor"='${businessUnit.rnc}'`;
        
        filters +=
          ` AND "FechaRecepcion"::DATE BETWEEN '${data.dateStart}' and '${data.dateEnd}'`;
        let resultInvoices = await this.api_Post("accounting/documents_recived_dgii", {
          filters: filters,
        });
  
        this.invoices = await resultInvoices.json();
        const cfMap = {
          '31': 'Factura de Crédito Fiscal Electrónico',
          '32': 'Factura de Consumo Electrónica',
          '33': 'Nota de Débito Electrónica',
          '34': 'Nota de Crédito Electrónica',
          '41': 'Compras Electrónico',
          '43': 'Gastos Menores Electrónico',
          '44': 'Regímenes Especiales Electrónico',
          '45': 'Gubernamental Electrónico',
        };
        this.invoices.forEach(inv => {
          const match = /<TipoeCF>(\d+)<\/TipoeCF>/.exec(inv.ContenidoXml);
          inv.tipoCF = match ? match[1] : '';
          inv.tipoCFDescription = cfMap[inv.tipoCF] || '';
          // Extract issuer name
          const nameMatch = /<RazonSocialEmisor>([^<]+)<\/RazonSocialEmisor>/.exec(inv.ContenidoXml);
          inv.emisorName = nameMatch ? nameMatch[1] : '';
        });
        
        // for (let key in this.invoices) {
        //   this.invoices[key].account_date_format = moment(
        //     this.invoices[key].account_date
        //   ).format("DD/MM/YYYY hh:mm: a");
        // }
        this.loading = false;
      },
      changeBusiness(data) {
        if (data.business == 0) {
          this.getData({
            business: this.$store.state.auth.user.acess_business_unit_finance,
            location: null,
            dateStart: data.dateStart,
            dateEnd: data.dateEnd,
          });
        } else {
          this.getData(data);
        }
      },
    
  
     
      formatDate(date) {
        return date ? moment(date).format('DD/MM/YYYY') : '';
      },
      formatCurrency(value) {
        return value != null
          ? new Intl.NumberFormat('es-DO', { style: 'currency', currency: 'DOP' }).format(value)
          : '';
      },
      // Navega a la vista de documento recibido en una nueva pestaña
      showDocument(rnc, encf) {
        // Construir la URL para la vista del documento
        const route = this.$router.resolve({ name: 'ViewDocumentRecived', params: { rnc, encf } });
        // Abrir en una nueva pestaña
        window.open(route.href, '_blank');
      },
    },
  };
  </script>
  
  <style></style>
  